module.exports = __webpack_public_path__ + "img/ew-icon_deals.16c6ea8a.svg";